import { render, staticRenderFns } from "./school-details.vue?vue&type=template&id=b0d22d38"
import script from "./school-details.vue?vue&type=script&lang=js"
export * from "./school-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports